/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";
import calculate_length from "@turf/length";
import along from "@turf/along";
import centroid from "@turf/centroid";

/*COMPONENT*/
import Modal from "../common_modal/Modal";

/*REDUX*/
import {
  set_value_layer,
  pushFeature,
  pushFeatureV2,
  editGeometry,
  editGeometryV2,
  deleteFeature,
} from "../../App/actions/layerActions";
import {
  set_value_toolbox,
  generate_elevation,
  push_value_toolbox,
  generate_isokron,
  status_toolbox,
} from "../../App/actions/toolboxActions";
import { set_value_sini } from "../../App/actions/sini_v2";
import { get_sini_data } from "../../App/actions/get_sini_data";
import { snackbar } from "../../App/actions/snackbarActions";

/*PICTURE*/
import polygon_double_correct from "../../Assets/svg/polygon_double_correct.svg";
import polygon_double_wrong from "../../Assets/svg/polygon_double_wrong.svg";
import icon_polygon_correct from "../../Assets/svg/icon_polygon_correct.svg";
import icon_polygon_wrong from "../../Assets/svg/icon_polygon_wrong.svg";
import icon_line_correct from "../../Assets/svg/icon_line_correct.svg";
import icon_line_wrong from "../../Assets/svg/icon_line_wrong.svg";
//test

/*FUNCTION*/
import draw_initiation from "./draw_initiation";
import on_draw_toolbox from "./on_draw_toolbox";
import on_draw_sini from "./on_draw_sini";
import { getAllFields, getGeoLayer } from "../../App/reduxHelper/layer";
import { generate_feature_base_value } from "../../App/validation/generateFeature";
import { validateKinksOfFeature } from "../../App/validation/coordinates_validation";

/*DATA*/
import domain_list from "../../Data/domain_list";
import dict from "../../Data/dict.json";

/*CONST*/
const snap_tolerance = {
  lng: 0.000009,
  lat: 0.000009,
};
const domain = window.location.host;

function convert_to_point(geojson) {
  return geojson.features
    .map((feature) => {
      if (!feature.geometry || !feature.geometry.type) return [];

      let coordinates = [];

      switch (feature.geometry.type) {
        case "Point":
          coordinates = [feature.geometry.coordinates];
          break;
        case "MultiPoint":
        case "LineString":
          coordinates = feature.geometry.coordinates;
          break;
        case "MultiLineString":
          coordinates = feature.geometry.coordinates.flat();
          break;
        case "Polygon":
          // Flatten all rings (outer + inner holes)
          coordinates = feature.geometry.coordinates.flat();
          break;
        case "MultiPolygon":
          // Flatten all rings in all polygons
          coordinates = feature.geometry.coordinates.flat(2);
          break;
        default:
          return [];
      }
      return coordinates.map((coord) => ({
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: coord,
        },
      }));
    })
    .flat();
}

class DRAW_GEO extends Component {
  state = {
    features_draw_length: 0,
    modal_error: false,
    error_type: "",
    geo_type: "",
  };
  previousMode = null;

  componentDidMount() {
    const map_object = this.props.layer.map_object;
    if (map_object) {
      map_object.on("load", () => {
        draw_initiation({
          map_object,
          on_create: this.on_create,
          on_update: this.on_update,
          on_delete: this.on_delete,
          on_draw_click: this.on_draw_click,
          set_value_layer: this.props.set_value_layer,
          on_modechange: this.on_modechange,
        });
      });
    }
    document.addEventListener("keydown", this.handle_esc_key); // Listen for the "Esc" key
  }

  componentWillUnmount() {
    const map_object = this.props.layer.map_object;
    if (map_object) {
      map_object
        .getCanvas()
        .removeEventListener("mousemove", this.handle_cursor_move); // Remove the event listener
    }
    document.removeEventListener("keydown", this.handle_esc_key); // Remove the "Esc" key listener
  }

  componentDidUpdate(prevProps) {
    const { map_object } = this.props.layer;
    const draw_object = this.props.layer.draw_object;

    const status_action_after = this.props.map.status_action;
    const status_action_before = prevProps.map.status_action;

    if (this.props.layer.map_object !== prevProps.layer.map_object) {
      if (map_object) {
        map_object.on("load", () => {
          draw_initiation({
            map_object,
            on_create: this.on_create,
            on_update: this.on_update,
            on_delete: this.on_delete,
            on_draw_click: this.on_draw_click,
            set_value_layer: this.props.set_value_layer,
            on_modechange: this.on_modechange,
          });
        });
      }
    }

    //check if the geometryStatus or layer_id has changed
    const geometryStatus_before = prevProps.layer.geometryStatus;
    const geometryStatus_after = this.props.layer.geometryStatus;
    const layer_id_before = prevProps.layer.layer_id;
    const layer_id_after = this.props.layer.layer_id;

    const draw_state_platform_after = this.props.layer.draw_state_platform;
    const draw_state_platform_before = prevProps.layer.draw_state_platform;

    if (
      (status_action_after !== status_action_before ||
        geometryStatus_before !== geometryStatus_after ||
        layer_id_before !== layer_id_after ||
        draw_state_platform_after !== draw_state_platform_before) &&
      draw_state_platform_after !== "toolbox"
    ) {
      if (geometryStatus_after && layer_id_after) {
        const { geo_layer_list } = this.props.layer;
        if (draw_object) {
          draw_object?.deleteAll();
        }
        const geo_layer = geo_layer_list.find(
          (item) => item?.geo_layer?._id === layer_id_after
        )?.geo_layer;
        const geojson = geo_layer?.geojson || {
          type: "FeatureCollection",
          features: [],
        };

        //1
        if (draw_object) {
          draw_object.add(geojson);
          draw_object.changeMode("simple_select");
        }

        //2
        const features_point_draw = convert_to_point(geojson);
        this.props.set_value_layer({
          key: "features_point_draw",
          value: features_point_draw,
        });
        map_object
          .getCanvas()
          .addEventListener("mousemove", this.handle_cursor_move);
      } else {
        map_object
          .getCanvas()
          .removeEventListener("mousemove", this.handle_cursor_move);
        draw_object?.deleteAll();
      }
    }
  }

  error_type_dict = (language = "ina", error_type, geo_type) => {
    let minOfPoints;
    if (geo_type === "Polygon") {
      minOfPoints = "3";
    } else if (geo_type === "LineString") {
      minOfPoints = "2";
    }

    if (!error_type) return {};

    const notes = {
      "not-in-same-point": {
        note: dict[
          "You have done the polygon drawing at the same point, which will end the digitizing process, minimum three points for polygon digitizing"
        ][language],
        correct:
          dict[
            "Correct: draw a polygon with sequential digitization of at least 3 different points"
          ][language],
        wrong:
          dict[
            "Wrong: drawing a polygon with digitization with only 2 points (the second and third points are at the same point)"
          ][language],
        correct_img: polygon_double_correct,
        wrong_img: polygon_double_wrong,
      },
      "self-intersection": {
        note: dict[
          "The _type_ you created intersects itself. Please create a _type_ that does not intersect itself."
        ][language].replace("_type_", geo_type),
        correct: dict[
          "Correct: create a _type_ that does not intersect itself"
        ][language].replace("_type_", geo_type),
        wrong: dict["Wrong: create a _type_ that intersects itself"][
          language
        ].replace("_type_", geo_type),
        correct_img:
          geo_type === "Polygon" ? icon_polygon_correct : icon_line_correct,
        wrong_img:
          geo_type === "Polygon" ? icon_polygon_wrong : icon_line_wrong,
      },
      "insufficient-points": {
        note: dict[
          "The _type_ you created does not have enough points. A _type_ must have at least _minOfPoints_ points."
        ][language]
          .replace("_minOfPoints_", minOfPoints)
          .replaceAll("_type_", geo_type),
        correct: dict[
          "Correct: create a _type_ with at least _minOfPoints_ different points"
        ][language]
          .replace("_minOfPoints_", minOfPoints)
          .replaceAll("_type_", geo_type),
        wrong: dict[
          "Wrong: create a _type_ with less than _minOfPoints_ different points"
        ][language]
          .replace("_minOfPoints_", minOfPoints)
          .replaceAll("_type_", geo_type),
        correct_img: icon_polygon_correct,
        wrong_img: polygon_double_wrong,
      },
      "not-closed": {
        note: dict[
          "The polygon you created is not closed. Please ensure that the first and last points of the polygon are the same."
        ][language],
        correct:
          dict[
            "Correct: create a polygon where the first and last points are the same"
          ][language],
        wrong:
          dict[
            "Wrong: create a polygon where the first and last points are different"
          ][language],
        correct_img: icon_polygon_correct,
        wrong_img: polygon_double_wrong,
      },
      "zero-area": {
        note: dict[
          "The polygon you created has zero area. Please create a polygon with a valid area greater than zero."
        ][language],
        correct:
          dict["Correct: create a polygon with a valid area greater than zero"][
            language
          ],
        wrong: dict["Wrong: create a polygon with zero area"][language],
        correct_img: icon_polygon_correct,
        wrong_img: polygon_double_wrong,
      },
    };

    return notes[error_type];
  };

  handle_cursor_move = (e) => {
    const geometryStatus = this.props.layer.geometryStatus;
    if (!geometryStatus) return;

    const { map_object, draw_object } = this.props.layer;
    if (map_object) {
      // Convert cursor pixel to geographic coordinates
      const coords = map_object.unproject([e.clientX, e.clientY]);
      const long_center = coords.lng;
      const lat_center = coords.lat;

      // Define snapping box (approx. 1 meter around cursor)
      const long_start = long_center - snap_tolerance.lng;
      const lat_start = lat_center - snap_tolerance.lat;
      const long_end = long_center + snap_tolerance.lng;
      const lat_end = lat_center + snap_tolerance.lat;

      const features_point_draw = this.props.layer.features_point_draw || [];

      // Filter points inside the snapping box
      let features_point_snap = features_point_draw.filter((feature) => {
        const long_test = feature?.geometry?.coordinates?.[0];
        const lat_test = feature?.geometry?.coordinates?.[1];

        const logic =
          long_test > long_start &&
          long_test < long_end &&
          lat_test > lat_start &&
          lat_test < lat_end;

        return logic;
      });

      if (features_point_snap.length > 0) {
        const mode = draw_object.getMode();

        if (mode === "direct_select") {
          // untuk mode edit
          const all_features = draw_object.getAll().features;
          const current_feature = all_features[all_features.length - 1];

          const geojson = {
            type: "FeatureCollection",
            features: [current_feature],
          };

          const current_point_features = convert_to_point(geojson);

          const current_coords_set = new Set(
            current_point_features.map(
              (f) => `${f.geometry.coordinates[0]},${f.geometry.coordinates[1]}`
            )
          );

          features_point_snap = features_point_snap.filter((feature) => {
            const [lng, lat] = feature?.geometry?.coordinates || [];
            return !current_coords_set.has(`${lng},${lat}`);
          });

          this.on_draw_update();
        }
      }

      if (features_point_snap.length > 0) {
        features_point_snap = [features_point_snap[0]];
      } else {
        features_point_snap = [];
      }

      // Render snap preview on map
      const layer_snap_id = "layer_snap_id";
      const geojson_snap = {
        type: "FeatureCollection",
        features: features_point_snap,
      };

      if (!map_object.getSource(layer_snap_id)) {
        map_object.addSource(layer_snap_id, {
          type: "geojson",
          data: geojson_snap,
        });
      } else {
        map_object.getSource(layer_snap_id).setData(geojson_snap);
      }

      if (!map_object.getLayer(layer_snap_id)) {
        map_object.addLayer({
          id: layer_snap_id,
          type: "circle",
          source: layer_snap_id,
          paint: {
            "circle-color": "red",
            "circle-radius": 5,
            "circle-stroke-width": 2,
            "circle-stroke-color": "#fff",
          },
          layout: {
            visibility: "visible",
          },
        });
      }

      this.props.set_value_layer({
        key: "features_point_snap",
        value: features_point_snap,
      });
    }
  };

  on_draw_click = async () => {
    try {
      const geometryStatus = this.props.layer.geometryStatus;

      if (!geometryStatus) return;

      const { draw_object, features_point_snap } = this.props.layer;
      const mode = draw_object?.getMode();

      let features_draw = draw_object.getAll().features;

      if (!features_draw.length) return;

      const feature_current = features_draw[features_draw.length - 1];
      const feature_id = feature_current?.id;
      const type = feature_current?.geometry?.type;
      const coordinates = feature_current?.geometry?.coordinates;
      let new_coordinates = coordinates;

      if (type === "Polygon") {
        const features_draw_length_now = features_draw?.length || 0;

        if (features_draw_length_now < this.state.features_draw_length) {
          this.setState({
            modal_error: true,
            error_type: "not-in-same-point",
          });
          draw_object.changeMode("simple_select");

          const { map_object } = this.props.layer;
          map_object.getCanvas().style.cursor = "";

          this.props.set_value_layer({
            key: "draw_active",
            value: false,
          });
        }

        this.setState({
          features_draw_length: features_draw?.length || 0,
        });
      }

      const lng_snap = features_point_snap?.[0]?.geometry?.coordinates?.[0];
      const lat_snap = features_point_snap?.[0]?.geometry?.coordinates?.[1];

      if (
        !draw_object ||
        !["draw_polygon", "draw_line_string"].includes(mode) ||
        !Array.isArray(features_point_snap) ||
        !features_point_snap?.[0]
      )
        return;

      if (type === "Polygon") {
        let ring = [...coordinates[0]];
        if (ring.length === 3) {
          ring = [
            [lng_snap, lat_snap],
            [lng_snap, lat_snap],
            [lng_snap, lat_snap],
          ];
        } else if (ring.length > 3) {
          ring[ring.length - 3] = [lng_snap, lat_snap];
          ring[ring.length - 2] = [lng_snap, lat_snap];
        }
        new_coordinates = [ring];
      } else if (type === "LineString") {
        if (coordinates.length === 2) {
          new_coordinates = [
            [lng_snap, lat_snap],
            [lng_snap, lat_snap],
          ];
        } else {
          new_coordinates = [...coordinates];
          new_coordinates[new_coordinates.length - 2] = [lng_snap, lat_snap];
          new_coordinates[new_coordinates.length - 1] = [lng_snap, lat_snap];
        }
      }

      const updated_feature = {
        type: "Feature",
        id: feature_id,
        properties: { ...feature_current.properties },
        geometry: {
          type: type,
          coordinates: new_coordinates,
        },
      };

      // Save selected feature ID to re-activate mode after set
      const selected_ids = draw_object.getSelectedIds();

      // Safely set updated feature
      features_draw[features_draw.length - 1] = updated_feature;
      draw_object.set({
        type: "FeatureCollection",
        features: features_draw,
      });

      // Re-activate direct_select mode after set to prevent crash (deferred)
      if (selected_ids.length) {
        const selected_id = selected_ids[0];
        setTimeout(() => {
          try {
            draw_object.changeMode("direct_select", { featureId: selected_id });
          } catch (err) {}
        }, 0); // defer to next tick
      }
    } catch (error) {}
  };

  on_draw_update = () => {
    const geometryStatus = this.props.layer.geometryStatus;
    if (!geometryStatus) return;

    const { draw_object, features_point_snap } = this.props.layer;
    const mode = draw_object?.getMode();

    if (
      !draw_object ||
      mode !== "direct_select" ||
      !Array.isArray(features_point_snap) ||
      !features_point_snap?.[0]
    )
      return;

    const features_draw = draw_object.getAll().features;

    if (!features_draw.length) return;

    const feature_current = features_draw[features_draw.length - 1];
    const { id, geometry, properties } = feature_current;
    const { type, coordinates } = geometry;
    const [lng_snap, lat_snap] = features_point_snap[0].geometry.coordinates;

    let new_coordinates = coordinates;

    if (type === "Polygon") {
      const ring = [...coordinates[0]];
      for (let i = 0; i < ring.length; i++) {
        const [lng, lat] = ring[i];
        if (
          Math.abs(lng - lng_snap) < snap_tolerance.lng &&
          Math.abs(lat - lat_snap) < snap_tolerance.lat
        ) {
          ring[i] = [lng_snap, lat_snap];
          break;
        }
      }
      new_coordinates = [ring];
    } else if (type === "LineString") {
      const line = [...coordinates];
      for (let i = 0; i < line.length; i++) {
        const [lng, lat] = line[i];
        if (
          Math.abs(lng - lng_snap) < snap_tolerance.lng &&
          Math.abs(lat - lat_snap) < snap_tolerance.lat
        ) {
          line[i] = [lng_snap, lat_snap];
          break;
        }
      }
      new_coordinates = line;
    } else {
      return;
    }

    const feature_updated = {
      type: "Feature",
      id,
      properties: { ...properties },
      geometry: {
        type,
        coordinates: new_coordinates,
      },
    };

    const updated_features = [...features_draw];
    updated_features[updated_features.length - 1] = feature_updated;

    // Update the feature using set()
    draw_object.set({
      type: "FeatureCollection",
      features: updated_features,
    });

    // Save selected feature ID to re-activate mode after set
    const selected_ids = draw_object.getSelectedIds();
    if (selected_ids.length) {
      const selected_id = selected_ids[0];
      setTimeout(() => {
        try {
          draw_object.changeMode("direct_select", { featureId: selected_id });
        } catch (err) {}
      }, 0); // defer to next event loop tick
    }

    this.props.set_value_layer({
      key: "features_point_snap",
      value: [],
    });
  };

  on_create = async (event) => {
    try {
      this.props.set_value_layer({
        key: "draw_active",
        value: false,
      });
      const { map_object, draw_state_platform } = this.props.layer;
      const draw_object = this.props.layer.draw_object;

      if (map_object) {
        map_object.getCanvas().style.cursor = ""; //reset cursor on map canvas
      }

      //panggil API pushFeature
      if (draw_state_platform === "geometry") {
        const feature = event?.features?.[0];
        const kinks = validateKinksOfFeature(feature);

        if (!kinks?.is_valid) {
          this.setState({
            modal_error: true,
            error_type: kinks?.errors?.[0]?.type,
            geo_type: feature.geometry.type,
          });
          draw_object.delete(feature.id);
          return;
        }

        const geometry = event?.features?.[0]?.geometry;
        const id = event?.features?.[0]?.id;
        const { layer_id, current_architecture } = this.props.layer;
        if (layer_id) {
          // nambahin data default (0 utk number dan "" utk string) pada properties
          const geo_layer = getGeoLayer(this.props.layer);
          const fields = getAllFields(geo_layer).filter(
            (field) => !field?.parent_uuid
          );
          const prop = { key: id, ...generate_feature_base_value(fields) };
          let feature = {
            type: "Feature",
            properties: prop,
            geometry: geometry,
            key: id,
            isHide: false,
            formStatus: { status: "digitasi" },
          };
          const body = {
            geo_layer_id: layer_id,
            feature,
          };
          if (current_architecture === "v2") {
            this.props.pushFeatureV2(body);
          } else {
            this.props.pushFeature(body);
          }

          if (
            [
              "localhost:3003",
              "dsdajakarta.mapid.io",
              "dsdajakarta-alpha.mapid.io",
              "dsdajakarta-beta.mapid.io",
            ].includes(domain)
          ) {
            // Show input popup
            const { type_2 } = geo_layer;
            const type = geometry?.type;
            let longitude, latitude;

            if (type === "Point") {
              [longitude, latitude] = geometry?.coordinates;
            } else if (type === "LineString") {
              const length_km = calculate_length(feature, {
                units: "kilometers",
              });
              const center = along(feature, length_km / 2, {
                units: "kilometers",
              });
              [longitude, latitude] = center?.geometry.coordinates;
            } else {
              const center = centroid({
                type: "FeatureCollection",
                features: [feature],
              });
              [longitude, latitude] = center?.geometry.coordinates;
            }

            const handleFullScreen = () => {
              this.props.set_value_layer({
                key: "modal_edit_feature_properties",
                value: true,
              });
              this.props.set_value_layer({
                key: "latitude_selected",
                value: latitude,
              });
              this.props.set_value_layer({
                key: "longitude_selected",
                value: longitude,
              });
              this.props.set_value_layer({
                key: "fields_selected",
                value: fields,
              });
              this.props.set_value_layer({
                key: "properties_selected",
                value: feature?.properties,
              });
              this.props.set_value_layer({
                key: "type_2_selected",
                value: type_2,
              });
              this.props.set_value_layer({
                key: "feature_key_selected",
                value: feature?.properties?.key,
              });
              this.props.set_value_layer({
                key: "geo_layer_selected",
                value: geo_layer,
              });
            };

            if (geo_layer?.fields?.length) {
              handleFullScreen();
            }
          }
        }
      } else if (draw_state_platform === "toolbox") {
        if (draw_object) {
          draw_object?.deleteAll();
          draw_object?.[1]?.changeMode("simple_select");
        }

        on_draw_toolbox({
          event,
          toolbox: this.props.toolbox,
          set_value_toolbox: this.props.set_value_toolbox,
          generate_elevation: this.props.generate_elevation,
          push_value_toolbox: this.props.push_value_toolbox,
          generate_isokron: this.props.generate_isokron,
          status_toolbox: this.props.status_toolbox,
        }); //fungsi untuk handle toolbox dipisahkan supaya mudah untuk maintenance
      } else if (draw_state_platform === "sini") {
        const { domain } = this.props.auth;
        const show_survey_1 = domain_list?.[domain]?.show_survey_1;

        on_draw_sini({
          event,
          sini: this.props.sini,
          get_sini_data: this.props.get_sini_data,
          set_value_sini: this.props.set_value_sini,
          set_value_layer: this.props.set_value_layer,
          show_survey_1,
        }); //fungsi untuk handle sini dipisahkan supaya mudah untuk maintenance

        if (draw_object) {
          draw_object?.deleteAll();
        }
      }
    } catch (error) {}
  };

  on_update = (event) => {
    //panggil API editGeometry
    if (["change_coordinates", "move"].includes(event?.action)) {
      const feature_key =
        event?.features?.[0]?.properties?.key || event?.features?.[0]?.id;
      const geometry = event?.features?.[0]?.geometry;
      const { layer_id, current_architecture } = this.props.layer;
      if (feature_key && geometry && layer_id) {
        const body = {
          feature_key: feature_key,
          geo_layer_id: layer_id,
          geometry: geometry,
        };
        if (current_architecture === "v2") {
          this.props.editGeometryV2(body);
        } else {
          this.props.editGeometry(body);
        }
      }
    } else {
    }
  };

  on_delete = (event) => {
    const map_object = this.props.layer.map_object;
    if (map_object) {
      map_object.getCanvas().style.cursor = ""; //reset cursor on map canvas
    }
    const { layer_id } = this.props.layer;
    const feature_key =
      event?.features?.[0]?.properties?.key || event?.features?.[0]?.id;
    const body = {
      feature_key: feature_key,
      geo_layer_id: layer_id,
    };
    if (layer_id && feature_key) {
      //panggil API deleteFeature
      this.props.deleteFeature(body);
    }
  };

  on_modechange = () => {};

  handle_esc_key = (event) => {
    this.props.set_value_layer({
      key: "draw_active",
      value: false,
    });
    this.props.set_value_toolbox({ key: "mode_draw", value: "simple_select" });
    if (event.key === "Escape") {
      const map_object = this.props.layer.map_object;
      const draw_object = this.props.layer.draw_object;

      if (draw_object) {
        draw_object.changeMode("simple_select");
        map_object.getCanvas().style.cursor = "";
      }
    }
  };

  toggle_error = () => {
    this.setState({
      modal_error: !this.state.modal_error,
    });
  };

  render() {
    const { modal_error, error_type, geo_type } = this.state;
    const language = localStorage?.language || this.props.auth.language;

    const geo_error_notes = this.error_type_dict(
      language,
      error_type,
      geo_type
    );

    return (
      <main>
        {modal_error && (
          <Modal
            modalSize="small"
            id="modal"
            isOpen={modal_error}
            onClose={this.toggle_error}
          >
            <div className="box-body">
              <p className="text_big margin_bottom">
                {dict?.["Drawing error"]?.[language]}
              </p>
              <p className="text_medium sub_color margin_bottom_extra">
                {geo_error_notes?.note}
              </p>
              <main className="text_center">
                <section className="container two_container_equal background_grey_light margin_bottom_extra">
                  <div className="text_center">
                    <img
                      className="margin_bottom"
                      alt="polygon_double_correct"
                      src={geo_error_notes?.correct_img}
                      width={89}
                      style={{ maxWidth: "30vw" }}
                    />
                    <br />
                    <p className="text_medium sub_color">
                      {geo_error_notes?.correct}
                    </p>
                  </div>
                  <div className="text_center">
                    <img
                      className="margin_bottom"
                      alt="polygon_double_wrong"
                      src={geo_error_notes?.wrong_img}
                      width={89}
                      style={{ maxWidth: "30vw" }}
                    />
                    <br />
                    <p className="text_medium sub_color">
                      {geo_error_notes?.wrong}
                    </p>
                  </div>
                </section>
                <button
                  className="button_big background_black"
                  onClick={this.toggle_error}
                >
                  {dict?.["Close"]?.[language]}
                </button>
              </main>
            </div>
          </Modal>
        )}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  map: state.map,
  auth: state.auth,
  layer: state.layer,
  toolbox: state.toolbox,
  sini: state.sini,
});

export default connect(mapStateToProps, {
  set_value_layer,
  pushFeature,
  pushFeatureV2,
  editGeometry,
  editGeometryV2,
  deleteFeature,
  set_value_toolbox,
  generate_elevation,
  push_value_toolbox,
  generate_isokron,
  get_sini_data,
  set_value_sini,
  status_toolbox,
  snackbar,
})(DRAW_GEO);
